import React, { forwardRef } from 'react'
import { MenuItem, styled } from '@mui/material'
import { Icon } from 'packages/eid-icons'
import { Avatar } from 'packages/eid-ui'

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    minWidth: '16rem',
    color: '#534e52',
    fontSize: '1.3rem',
    position: 'relative',
    backgroundColor: 'transparent !important',

    '& img': {
        opacity: 0.5,
        filter: 'grayscale(100%) ',
        width: '2.4rem',
        height: '2.4rem',
    },
    '& .languageMenuLabel': {
        paddingLeft: '1.2rem',
    },
    '&:hover': {
        backgroundColor: 'transparent !important',

        '& img': {
            opacity: 1,
            filter: 'grayscale(0%)',
        },
    },
    '&.Mui-selected': {
        backgroundColor: 'transparent !important',
        '& img': {
            opacity: 1,
            filter: 'grayscale(0%) ',
        },
    },
}))

const LanguageMenuItem = forwardRef(
    ({ displayName, avatarSrc, selected, onClick }, ref) => {
        return (
            <StyledMenuItem
                onClick={onClick}
                selected={selected}
                ref={ref}
                tabIndex={0}
            >
                <Avatar size="small" src={avatarSrc} />
                <span className="languageMenuLabel">{displayName}</span>

                {selected && (
                    <Icon
                        name="Check"
                        width="0.8rem"
                        height="0.6rem"
                        color="#0057A0"
                        style={{
                            position: 'absolute',
                            right: '0.8rem',
                            top: 'calc(50% - 0.3rem)',
                        }}
                    />
                )}
            </StyledMenuItem>
        )
    },
)

export default LanguageMenuItem
